import * as React from 'react';

import type { RenderElementProps } from 'slate-react';

import AIIndicator from 'bundles/cml/editor/components/elements/ai/AIIndicator';

const AICursor: React.FC<RenderElementProps> = ({ attributes, children }) => {
  return (
    <span contentEditable={false} {...attributes}>
      <span>{children}</span>
      <span contentEditable={false}>
        <AIIndicator />
      </span>
    </span>
  );
};

export default AICursor;
